import {defineStore} from "pinia/dist/pinia";

export const useEndpointStore = defineStore('EndpointStore', {
    state() {
        return {
            endpointState: null,
            iaDomain: "ia-press-portal.esmo.org",
            uaDomain: "ua-press-portal.esmo.org",
            proDomain: "press-portal.esmo.org",
            iaBackend: "graphql.eks-uat.aws.esmo.org",
            uaBackend: "graphql.eks-uat.aws.esmo.org",
            proBackend: "graphql.eks-prod.aws.esmo.org",
            onSubmitRedirectUrlState: "https://www.esmo.org/newsroom/press-and-media-hub",
            selfRedirectState: false,
            apiKeyState: null
        }
    },
    getters: {
        selfRedirect() {
            return this.selfRedirectState
        },
        onSubmitRedirectUrl() {
            return this.onSubmitRedirectUrlState
        },
        endpoint() {
            if (location.hostname === this.proDomain) {
                return "https://" + this.proBackend
            } else if (location.hostname === this.uaDomain) {
                return "https://" + this.uaBackend
            } else if (location.hostname === this.iaDomain) {
                return "https://" + this.iaBackend
            } else if (location.hostname.search("localhost") !== -1) {
                return "http://localhost:50001"
            }
        },
        apiKey() {
            return this.apiKeyState
        }
    },
    actions: {
        setSelfRedirect(selfRedirect) {
            this.selfRedirectState = selfRedirect
        },
        setOnSubmitRedirectUrl(onSubmitRedirectUrl) {
            this.onSubmitRedirectUrlState = onSubmitRedirectUrl
        },
        setEndpoint(endpoint) {
            this.endpointState = endpoint
        }, logout() {
            this.$reset()
        },
        setApiKey(apiKey) {
            this.apiKeyState = apiKey
        }
    },
    persist: {
        storage: sessionStorage
    }
})
